export class KydVehicleEligibility {
  isVehicleEligible: boolean;
  canEnroll: boolean;
  vin: string;
}
